import React from 'react'
import colours from '../lib/colours'
import styled from 'styled-components'
import IEventedComponent from '../components/IEventedComponent'

const StyledBackground = styled.div`
  width: 100%;
  background-color: ${colours.white} !important;
`

const ContentDiv = styled.div`
  color: ${colours.darkPurple};
  padding-top: 40px;
  padding-bottom: 20px;
`

interface IProps {}

interface IState {}

class MainContent extends IEventedComponent<IProps, IState> {
  render() {
    return (
      <StyledBackground>
        <div className="container">
          <ContentDiv>{this.props.children}</ContentDiv>
        </div>
      </StyledBackground>
    )
  }
}

export default MainContent
